import { useMutation, useQueryClient } from 'react-query';
import { getUserAvatarAPI } from '@myme/api';
import { uploadUserAvatar } from '@myme/logic';
import { useTranslation } from 'src/hooks';
import { handleError, toast, ToastType } from 'src/utils';

export const useUploadUserAvatarMutation = (onClose: () => void) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const uploadBannerMutation = useMutation(async (formData: FormData) => uploadUserAvatar(formData), {
    onSuccess: () => {
      toast(ToastType.SUCCESS, t('pages.profile.settings_page_creator.upload_avatar_toast_success'));
      queryClient.resetQueries(getUserAvatarAPI.cacheKeys);

      onClose();
    },
    onError: err => {
      handleError(err, {
        displayCustomToast: () => toast(ToastType.ERROR, t('errors.profile.upload_avatar'))
      });
    }
  });

  return uploadBannerMutation;
};
